import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'
import { IRmaLineDTO, parseRmaLineDTO, RmaLineDTO } from 'components/ordering/rma/api/dtos/rma-line-dto.js'

export type IRmaDetailHeaderDTO = {
  rma_id: string
  // number/sent/user_email can be null for drafts or ERP-synced RMAs; keep them
  // nullable so a missing value can't fail validation and blank the whole detail
  number: string | null
  erp_reference: string | null
  sent: string | null
  last_update: string | null
  state: string
  status: string
  interface_state: string
  user: string
  user_email: string | null
  comment: string | null
}

export type IRmaDetailDTO = {
  header: IRmaDetailHeaderDTO
  lines: IRmaLineDTO[]
}

export class RmaDetailHeaderDTO {
  rmaId: string
  number: string | null
  erpReference: string | null
  sent: string | null
  lastUpdate: string | null
  state: string
  status: string
  interfaceState: string
  user: string
  userEmail: string | null
  comment: string | null

  constructor(data: IRmaDetailHeaderDTO) {
    this.rmaId = data.rma_id
    this.number = data.number
    this.erpReference = data.erp_reference
    this.sent = data.sent
    this.lastUpdate = data.last_update
    this.state = data.state
    this.status = data.status
    this.interfaceState = data.interface_state
    this.user = data.user
    this.userEmail = data.user_email
    this.comment = data.comment
  }
}

export class RmaDetailDTO {
  header: RmaDetailHeaderDTO
  lines: RmaLineDTO[]

  constructor(data: IRmaDetailDTO) {
    this.header = new RmaDetailHeaderDTO(data.header)
    this.lines = data.lines.map(parseRmaLineDTO)
  }
}

const validate = createValidate<IRmaDetailDTO>()

export const parseRmaDetailDTO = (data: unknown): RmaDetailDTO => {
  validateGuard(validate, data, 'rma detail')
  return new RmaDetailDTO(data)
}
